export enum ClassificationType {
    IPC = 'IPC',
    CPC = 'CPC',
    UPC = 'UPC',
}

export type ClassificationDesc = {
    [key: string]: string;
}

export interface ClassificationBasicItem {
    id: string;
    has_children: boolean;
    lang_desc_map: ClassificationDesc;
}

export interface ClassificationPagination {
    start: number;
    rows: number;
    numFound: number;
}
